import React from 'react';
import AnalyticsPageLayout from '../components/analytics/AnalyticsPageLayout';
import SponsoredCohortLoginAnalytics from '../components/SponsoredCohortLoginAnalytics';
import SponsoredCohortLoginRawData from '../components/SponsoredCohortLoginRawData';

const TABS = [
  { title: 'Login analytics', component: <SponsoredCohortLoginAnalytics /> },
  { title: 'Raw login data', component: <SponsoredCohortLoginRawData /> },
];

function CohortLoginsAnalytics() {
  return (
    <AnalyticsPageLayout
      title="Cohort Logins"
      description="Login activity and engagement for students, broken down by cohort."
      tabs={TABS}
    />
  );
}

export default CohortLoginsAnalytics;
